// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 签名图片 popover 防止图片过大超出屏幕 */\n.sign-img-popover {\n  max-height: 80vh;\n  overflow: auto;\n}\n.popover-img-wrap {\n  max-width: 100%;\n}\n.popover-img-wrap img {\n  display: block;\n  max-width: 100%;\n  max-height: 65vh;\n  -o-object-fit: contain;\n     object-fit: contain;\n}", ""]);
// Exports
module.exports = exports;
